// Pantheon — Aegis Assault: every 3 autos, Pantheon braces his shield
// and becomes immune to damage for 1 turn.

import type { Ability, AbilityHit } from "./Ability";

export const pantheonShield: Ability = {
  id: "pantheonShield",
  displayName: "Aegis Assault",
  description: "Every 3rd attack, becomes immune to all damage for 1 turn.",
  iconId: "PantheonW",

  targetShape({ caster }) {
    return [caster.pos];
  },

  computeHits({ caster }): AbilityHit[] {
    return [{
      target: caster,
      amount: 0,
      type: "none",
      effect: { kind: "damageReduction", percent: 1.0, duration: 1 },
    }];
  },
};
